import { Swiper } from "swiper";
import { Navigation, Pagination, Controller, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/controller";
import "swiper/css/autoplay";

window.Swiper = Swiper;
window.Swiper_Pagination = Pagination;
window.Swiper_Navigation = Navigation;
window.Swiper_Controller = Controller;
window.Swiper_Autoplay = Autoplay;